import { ProductType } from '@shared/enums/product-type';

export class IUserProductUsage {
  productType: ProductType;
  variantType: string;
  description: string;
  hasLessonPlan: boolean;
  currentLesson?: string;
}
